import React,{useState} from 'react'
import CmsNavbar from '../../CmsComponents/CmsNavbar';
import CmsSidebar from '../../CmsComponents/CmsSidebar';
import Dashboard from '../../CmsComponents/Dashboard';

function DashboardPage() {
    const [isOpen,setIsOpen]= useState(false);

    function HandleClicked() {
        setIsOpen(!isOpen);
    }

    return (
        <div>
            <CmsNavbar action={HandleClicked} />
            <CmsSidebar isOpen={isOpen} />
            <Dashboard isOpen={isOpen} />
        </div>
    )
}

export default DashboardPage;
